<!-- <div class="container flex flex-column justify-content-center align-items-center" *ngIf="busy">
    <p-progressSpinner></p-progressSpinner>
</div> -->


<!-- <div class="dash-container grid" *ngIf="!busy"> -->
<div class="dash-container grid">
    <div class="linha1 col-12">
        <p-progressSpinner *ngIf="busyCards" class="flex flex-column justify-content-center align-items-center"></p-progressSpinner>
        <p-carousel *ngIf="!busyCards" [value]="cards" [numVisible]="6" [numScroll]="3" [circular]="false" [responsiveOptions]="responsiveOptions" [styleClass]="'col-12'" [style]="{ 'width': '100%'}">
            <ng-template let-card pTemplate="item">
                <div class="text-center border-round-sm font-bold">
                    <p-card styleClass="dashboard-card {{card.class}}">
                            <ng-template pTemplate="header">
                                <!-- <i class="pi {{card.icon}}" style="font-size: 1.25rem"></i> -->
                                <i class="pi {{card.icon}}" style="font-size: 1rem"></i>

                                <p>{{card.title}}</p>
                            </ng-template>

                            <div class="card-content">
                                <p class="card-valor">{{card.valor}}</p>
                            </div>

                        </p-card>
                </div>
            </ng-template>
        </p-carousel>
    </div>


    <div class="col-12">
        <div class="grid m-0">
            <div class="col-12 md:col-12 xl:col-12">
                <p-progressSpinner *ngIf="busyLocalizacoes" class="flex flex-column justify-content-center align-items-center"></p-progressSpinner>
                <div class="text-center font-bold">
                    <div class="card" *ngIf="!busyLocalizacoes">
                        <p-chart class="desktop" type="bar" [height]="'calc(100vh - 235px)'" [data]="basicData" [options]="basicOptions"></p-chart>
                        <p-chart class="mobile" type="bar" [height]="'calc(100vh - 480px)'" [data]="basicData" [options]="basicOptions"></p-chart>
                        <p-chart class="sm-mobile" type="bar" [height]="'calc(100vh - 150px)'" [data]="basicData" [options]="basicOptions"></p-chart>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>